exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Pages-local__pages--FYHBc {\n  border: 1px solid #18a0fb;\n  border-radius: 4px;\n  padding: 0.5rem;\n  background-color: #fff;\n  max-height: 24.375rem;\n  overflow-y: auto; }\n  .Pages-local__pages--FYHBc li {\n    padding: .25rem; }\n\n.Pages-local__fetching--1Mr8O {\n  height: 5rem;\n  background-color: #EEE;\n  border-radius: 4px;\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"pages": "Pages-local__pages--FYHBc",
	"fetching": "Pages-local__fetching--1Mr8O"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/portal/portal/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src","node_modules/slick-carousel/slick"]}!./src/components/Settings/ManageLayout/Bloc/Pages/Pages.local.scss
// module id = 817
// module chunks = 0